module.exports = __webpack_public_path__ + "static/media/kassouf-logo.77654a7c.png";